<table #tabelaDocumentos mat-table [dataSource]="listaInvestimento" class="table" aria-label="Elements">
  <ng-container matColumnDef="dataInvestimento">
    <th mat-header-cell *matHeaderCellDef>Data Investimento</th>
    <td mat-cell *matCellDef="let investimento">
      <p *ngIf="investimento?.dataInvestimento; else semData">
        {{ investimento?.dataInvestimento | date: 'shortDate' }}
      </p>

      <ng-template #semData>
        <p>
          Rodada Aberta
        </p>
      </ng-template>
    </td>
  </ng-container>

  <ng-container matColumnDef="valorInvestido">
    <th mat-header-cell *matHeaderCellDef>Valor Investido</th>
    <td mat-cell *matCellDef="let investimento">
      <p>
        {{ investimento.valorInvestido  | currency }}
      </p>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="colunasTabelaDocumentos"></tr>
  <tr mat-row *matRowDef="let row; columns: colunasTabelaDocumentos;"></tr>
</table>
